export const player = {
  namespaced: true,
  state: getInitialState(),
  actions: {
    playAudio({ commit, state }, { audios, audioId }) {
      const audio = state.audios.find((a) => a.id === audioId);
      if (!audio) {
        commit('resetState');
        commit('setAudios', { audios });
      }
      commit(
        'setCurrentAudio',
        audios.find((a) => a.id === audioId)
      );
      commit('setIsPlaying', true);
      commit('setIsOpen', true);
    },
    playNext({ commit, state, getters }) {
      const currentAudioIndex = getters.currentAudioIndex;
      if (currentAudioIndex < state.audios.length - 1) {
        commit('setCurrentAudio', state.audios[currentAudioIndex + 1]);
      } else {
        commit('setCurrentAudio', state.audios[0]);
      }
    },
    playPrev({ commit, state, getters }) {
      const currentAudioIndex = getters.currentAudioIndex;
      if (currentAudioIndex > 0) {
        commit('setCurrentAudio', state.audios[currentAudioIndex - 1]);
      } else {
        commit('setCurrentAudio', state.audios[state.audios.length - 1]);
      }
    },
  },
  mutations: {
    setIsOpen(state, isOpen) {
      state.isOpen = isOpen;
    },
    setAudios(state, { audios }) {
      state.audios = audios;
    },
    setCurrentAudio(state, audio) {
      state.currentAudio = audio;
    },
    resetState(state) {
      Object.assign(state, getInitialState());
    },
    setIsPlaying(state, isPlaying) {
      state.isPlaying = isPlaying;
    },
  },
  getters: {
    playbackLength: (state) => {
      return state.audios.length;
    },
    currentAudioIndex: (state) => {
      return state.audios.findIndex((a) => a.id === state.currentAudio.id);
    },
  },
};

function getInitialState() {
  return {
    currentAudio: null, // multiple
    isPlaying: false,
    isOpen: false,
    currentPlaylistId: null,
    audios: [],
    volume: 0.5,
    muted: false,
  };
}
